import React, { useEffect, useState } from "react";
import "./Closed.css";

import logo, { logoOnDark } from "../assets/logo.js";
import MailchimpSignup from "../components/MailchimpSignup";
import { DROP_AT, formatCountdown } from "../config/Drop";
import { useHomeVideo } from "../config/HomeVideos";

export default function ClosedPreDrop() {
  const [now, setNow] = useState(() => new Date());

  // Même vidéo et même logique de couleur que la home, pour que les deux
  // pages ne divergent pas.
  const { darkText } = useHomeVideo();

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 500);
    return () => clearInterval(t);
  }, []);

  const timeStr = formatCountdown(DROP_AT.getTime() - now.getTime());

  return (
    <div
      className={`closedPlain closedPlain--onVideo${
        darkText ? " closedPlain--darkText" : ""
      }`}
    >

      <div className="closedPlain__center">
        <img
          className="closedVideo__logo"
          src={darkText ? logo : logoOnDark}
          alt="Ghetto Symphony"
        />

        <div className="closedVideo__title">site closed</div>

        <div className="closedVideo__count">{timeStr}</div>

        <div className="closedVideo__formWrap">
          <MailchimpSignup cta="notify me" />
        </div>
      </div>
    </div>
  );
}
